import { createFileRoute } from "@tanstack/react-router";

import { loadNewAsset } from "../assets/loaders.ts";
import { NewAssetPage } from "../assets/new-asset-page.tsx";
import { canAddAssets } from "../assets/permissions.ts";
import { useViewer } from "../data/hooks.ts";
import { FormPending } from "../shell/record-pending.tsx";
import { newAssetSearch } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || !canAddAssets(viewer) ? <NoAccessPage /> : <NewAssetPage viewer={viewer} />;
};

export const Route = createFileRoute("/_app/assets/new")({
  validateSearch: newAssetSearch,
  loader: async ({ context }) => loadNewAsset(context.data),
  pendingComponent: () => <FormPending />,
  component: Page,
});
